import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarDays, Users, ChevronRight } from "lucide-react";
import { athleteClient } from "@/lib/api";
import { useT } from "@/lib/i18n";

const DAYS_EL = ["Κυριακή", "Δευτέρα", "Τρίτη", "Τετάρτη", "Πέμπτη", "Παρασκευή", "Σάββατο"];
const DAYS_EN = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export const UpcomingCourtBookings = () => {
  const { lang } = useT();
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => { athleteClient.get("/courts/my").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  if (!items) return null;
  const el = lang === "el";
  const dayName = (iso) => (el ? DAYS_EL : DAYS_EN)[new Date(`${iso}T12:00:00`).getDay()];
  const fmt = (iso) => { const [y, m, d] = iso.split("-"); return `${d}/${m}/${y}`; };
  return (
    <section className="mb-10" data-testid="upcoming-court-bookings">
      <div className="flex items-end justify-between mb-3">
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500 font-bold">{el ? "Γήπεδο" : "Court"}</div>
          <h2 className="font-heading font-black text-lg md:text-xl text-slate-900">{el ? "Οι επόμενες κρατήσεις μου" : "My upcoming bookings"}</h2>
        </div>
        <button onClick={() => navigate("/courts")} data-testid="upcoming-court-all" className="text-sm font-semibold text-ocean hover:underline inline-flex items-center gap-1">{el ? "Όλες οι κρατήσεις" : "All bookings"} <ChevronRight className="h-4 w-4" /></button>
      </div>
      {items.length === 0 ? (
        <div className="rounded-3xl border border-dashed border-slate-200 bg-white p-5 text-sm text-slate-500 flex flex-wrap items-center justify-between gap-3" data-testid="upcoming-court-empty">
          {el ? "Δεν έχεις επερχόμενες κρατήσεις γηπέδου." : "No upcoming court bookings."}
          <button onClick={() => navigate("/courts")} data-testid="upcoming-court-book" className="h-9 px-4 rounded-full bg-ocean text-white text-xs font-bold">{el ? "Κάνε κράτηση" : "Book a court"}</button>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((b) => (
            <button key={b.id} onClick={() => navigate(`/courts?court=${b.court_id}&week=${b.date}&day=${b.date}&slot=${b.start_time}`)} data-testid={`upcoming-court-card-${b.id}`}
              className="text-left bg-white rounded-3xl shadow-soft border border-slate-100 p-5 hover:shadow-lg hover:-translate-y-0.5 transition-all">
              <div className="flex items-center justify-between">
                <span className="text-xs uppercase tracking-widest text-sunset font-bold">{dayName(b.date)}</span>
                <span className="h-9 w-9 rounded-xl bg-ocean text-white flex items-center justify-center"><CalendarDays className="h-4 w-4" /></span>
              </div>
              <div className="mt-2 font-heading font-black text-2xl text-slate-900">{b.start_time} – {b.end_time}</div>
              <div className="text-sm text-slate-600">{fmt(b.date)} · {b.court_name}</div>
              <div className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-700" data-testid={`upcoming-court-count-${b.id}`}><Users className="h-3.5 w-3.5" /> {b.count}/{b.max} {el ? "αθλητές" : "athletes"}</div>
            </button>
          ))}
        </div>
      )}
    </section>
  );
};
